import { useFaqWidget } from "../../../providers/context";
import { Sheet, SheetContent } from "~/components/ui/sheet";
import { Tabs, TabsContent } from "~/components/ui/tabs";
import { SearchBar } from "../SearchBar";
import { FaqSidebarTabs } from "./tabs";
import { Toc } from "../Toc";
import { Bookmarks } from "../Bookmarks";
import { Group } from "~/components/ui/group";
import { CloseButton } from "~/components/ui/close";
import { BoldText } from "~/components/ui/text";
import { TranslationField } from "~/components/TranslationField";

export function FaqSidebarMobile() {

	const {
		openSheet,
		setOpenSheet,
		tab,
		setTab,
		faqName
	} = useFaqWidget();

	return (
		<Sheet
			open={openSheet()}
			onOpenChange={setOpenSheet}
		>
			<SheetContent
				class="w-full relative overflow-y-auto pt-0 px-0"
				position="left"
			>
				<Tabs value={tab()} onChange={setTab}>
					<div class="border-b flex flex-col space-y-4 sticky top-0 left-0 right-0 bg-white z-50">
						<Group class="px-4 pt-4 relative">
							<TranslationField key={faqName()}>
								{(name) => (
									<BoldText class="text-2xl">
										{name()}
									</BoldText>
								)}
							</TranslationField>
							<CloseButton onClick={() => setOpenSheet(false)} />
						</Group>
						<div class="px-4 flex flex-col space-y-4 pb-4">
							<SearchBar />
							<FaqSidebarTabs />
						</div>
					</div>
					<TabsContent class="px-4" value="toc">
						<Toc />
					</TabsContent>
					<TabsContent class="px-4" value="bookmarks">
						<Bookmarks />
					</TabsContent>
				</Tabs>
			</SheetContent>
		</Sheet>
	);
}